module.exports = __webpack_public_path__ + "static/ideation-selection-602c966834ff297dc5e1352696871cce.svg";